import { useTableActionContext } from '@aibees/elephant/context';
import { useFilterLabelsByOwnershipTab } from '@aibees/elephant/hooks/labels/use-label-ownership-tabs';
import { Label } from '@aibees/elephant/types/label';
import { useMemo } from 'react';

interface UseDisabledClearParams {
  labels: Label[];
  isLabel: boolean;
}

export function useDisabledClear({
  labels,
  isLabel,
}: UseDisabledClearParams): boolean {
  const {
    labels: globalLabels,
    lists: globalLists,
    tabValue,
  } = useTableActionContext();
  const filterByOwnershipTab = useFilterLabelsByOwnershipTab();

  return useMemo(() => {
    const array = isLabel ? globalLabels : globalLists;

    const filteredLabels = filterByOwnershipTab(labels, tabValue);

    if (filteredLabels.length === 0) {
      return true;
    }

    const filteredArray = filterByOwnershipTab(array, tabValue);

    const labelsIds = filteredLabels.map((x) => x.id);
    const arrayIds = new Set(filteredArray.map((x) => x.id));

    return !labelsIds.some((id) => arrayIds.has(id));
  }, [
    globalLabels,
    globalLists,
    labels,
    isLabel,
    tabValue,
    filterByOwnershipTab,
  ]);
}
